import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  CtaPropTypes,
  FontAdjustmentPropTypes,
  WPImagesPropType,
} from 'utils/propTypes';
import cx from 'utils/classnames';
import { capitalizeFirstLetter } from 'utils/stringHelpers';
import CtaButton from 'components/blocks/ctaButton/CtaButton';
import ResponsiveImage from 'components/base/responsiveImage/ResponsiveImage';
import DefaultErrorBoundary from 'components/error-boundaries/DefaultErrorBoundary';
import GlobalContext from 'hooks/contexts/GlobalContext';
import { TMS_EVENT_TYPES as EventTypes } from 'utils/analytics/EVENT_TYPES';

export default function HeroDefault({
  background,
  customCssClass,
  cta,
  variation,
  images,
  title,
  subTitle,
  titleFontAdjustment,
  subtitleFontAdjustment,
  heroRef,
}) {
  const {
    windowSize: { currentBreakpoint },
  } = useContext(GlobalContext);

  const responsiveImageSizes = {
    MOBILE: '100vw',
    TABLET: '100vw',
    DESKTOP: '100vw',
    DEFAULT: '100vw',
  };

  const heroClassName = cx({
    heroDefault: true,
    [`heroDefault--variation${
      variation ? capitalizeFirstLetter(variation) : ''
    }`]: !!variation,
    [`heroDefault--background${
      background ? capitalizeFirstLetter(background) : ''
    }`]: !!background,
    [`heroDefault--${customCssClass}`]: !!customCssClass,
  });

  return (
    <div className={heroClassName} ref={heroRef}>
      <div className="heroDefault__inner">
        <div className="heroDefault__content">
          <div className="heroDefault__imgContainer">
            <div className="heroDefault__imgContainerInner">
              <DefaultErrorBoundary meta={{ component: 'ResponsiveImage' }}>
                <ResponsiveImage
                  images={images}
                  className="heroDefault__img"
                  sizes={responsiveImageSizes}
                  fetchpriority="high"
                />
              </DefaultErrorBoundary>
            </div>
          </div>
          <div className="heroDefault__contentContainer">
            <div className="heroDefault__copy">
              <div
                className="heroDefault__titleWrap"
                style={{
                  '--fontSizeAdjustment': `${
                    titleFontAdjustment[currentBreakpoint] || 0
                  }`,
                }}
              >
                <h1
                  className="heroDefault__title"
                  dangerouslySetInnerHTML={{ __html: title }}
                />
                {subTitle && (
                  <div
                    className="heroDefault__subtitleWrap"
                    style={{
                      '--fontSizeAdjustment': `${
                        subtitleFontAdjustment[currentBreakpoint] || 0
                      }`,
                    }}
                  >
                    <div
                      className="heroDefault__subtitle"
                      dangerouslySetInnerHTML={{ __html: subTitle }}
                    />
                  </div>
                )}
              </div>
              {cta.useCTA && (
                <div className="heroDefault__cta">
                  <CtaButton {...cta} trackingLabel={EventTypes.Hero} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

HeroDefault.propTypes = {
  background: PropTypes.string,
  customCssClass: PropTypes.string,
  titleFontAdjustment: FontAdjustmentPropTypes,
  subtitleFontAdjustment: FontAdjustmentPropTypes,
  heroRef: PropTypes.shape({ current: PropTypes.any }),
  images: WPImagesPropType,
  subTitle: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  variation: PropTypes.string.isRequired,
  cta: CtaPropTypes,
};
